import { gql } from '@apollo/client'

export const CREATE_PLAN = gql`
  mutation CreateBillingProviderProduct(
    $billingProviderProduct: BillingProviderProductInput!
    $billingProviderProductPrices: [BillingProviderProductPriceInput]
    $billingProviderProductText: [BillingProviderProductTextInput]
    $updateProvider: Boolean = true
  ) {
    createBillingProviderProduct(
      billingProviderProduct: $billingProviderProduct
      billingProviderProductPrices: $billingProviderProductPrices
      billingProviderProductText: $billingProviderProductText
      updateProvider: $updateProvider
    ) {
      id
    }
  }
`

export const UPDATE_PLAN = gql`
  mutation UpdateBillingProviderProduct(
    $input: BillingProviderProductUpdateInput!
    $createBillingProviderProductPrices: [BillingProviderProductPricingCreateInput]
    $updateBillingProviderProductPrices: [BillingProviderProductPricingUpdateInput]
    $deleteBillingProviderProductPrices: [BillingProviderProductDeleteByIdInput]
    $createBillingProviderProductText: [BillingProviderProductTextCreateInput]
    $updateBillingProviderProductText: [BillingProviderProductTextUpdateInput]
    $deleteBillingProviderProductText: [BillingProviderProductDeleteByIdInput]
    $updateProvider: Boolean!
    $updateRelatedBillingProviderProducts: Boolean!
  ) {
    updateBillingProviderProduct(
      input: $input
      createBillingProviderProductPrices: $createBillingProviderProductPrices
      updateBillingProviderProductPrices: $updateBillingProviderProductPrices
      deleteBillingProviderProductPrices: $deleteBillingProviderProductPrices
      createBillingProviderProductText: $createBillingProviderProductText
      updateBillingProviderProductText: $updateBillingProviderProductText
      deleteBillingProviderProductText: $deleteBillingProviderProductText
      updateProvider: $updateProvider
      updateRelatedBillingProviderProducts: $updateRelatedBillingProviderProducts
    ) {
      id
    }
  }
`

export const CREATE_PRICE = gql`
  mutation CreateBillingProviderProductPrice(
    $input: BillingProviderProductPricingCreateInput!
    $updateProvider: Boolean!
    $updateRelatedBillingProviderProducts: Boolean!
  ) {
    createBillingProviderProductPrice(
      input: $input
      updateProvider: $updateProvider
      updateRelatedBillingProviderProducts: $updateRelatedBillingProviderProducts
    ) {
      id
    }
  }
`

export const UPDATE_PRICE = gql`
  mutation UpdateBillingProviderProductPrice(
    $input: BillingProviderProductPricingUpdateInput!
    $updateProvider: Boolean!
    $updateRelatedBillingProviderProducts: Boolean!
  ) {
    updateBillingProviderProductPrice(
      input: $input
      updateProvider: $updateProvider
      updateRelatedBillingProviderProducts: $updateRelatedBillingProviderProducts
    ) {
      id
    }
  }
`

export const DELETE_PRICE = gql`
  mutation DeleteBillingProviderProductPrice($id: ID!, $updateProvider: Boolean!) {
    deleteBillingProviderProductPrice(id: $id, updateProvider: $updateProvider) {
      success
    }
  }
`

export const CREATE_TEXT = gql`
  mutation CreateBillingProviderProductText($input: BillingProviderProductTextCreateInput!) {
    createBillingProviderProductText(input: $input) {
      id
    }
  }
`

export const UPDATE_TEXT = gql`
  mutation UpdateBillingProviderProductText($input: BillingProviderProductTextUpdateInput!) {
    updateBillingProviderProductText(input: $input) {
      id
    }
  }
`

export const DELETE_TEXT = gql`
  mutation DeleteBillingProviderProductText($id: ID!) {
    deleteBillingProviderProductText(id: $id) {
      success
    }
  }
`

export const CREATE_BONUS = gql`
  mutation CreateEcommerceSkuMapping($ecommerceSkuMapping: EcommerceSkuMappingCreateInput!) {
    ecommerceSkuMappingCreate(ecommerceSkuMapping: $ecommerceSkuMapping) {
      ecommerceSkuMapping {
        contentProviderKey
      }
    }
  }
`

export const UPDATE_BONUS = gql`
  mutation EcommerceSkuMappingUpdateByProviderAndEcommerceSku(
    $ecommerceSkuMapping: EcommerceSkuMappingUpdateByProviderAndEcommerceSkuInput!
  ) {
    ecommerceSkuMappingUpdateByProviderAndEcommerceSku(ecommerceSkuMapping: $ecommerceSkuMapping) {
      ecommerceSkuMapping {
        ecommerceSku
      }
    }
  }
`

export const CREATE_PLAN_BONUS = gql`
  mutation EcommerceSkuMappingBonusEligibilityCreate(
    $input: EcommerceSkuMappingBonusEligibilityCreateInput!
  ) {
    ecommerceSkuMappingBonusEligibilityCreate(ecommerceSkuMappingBonusEligibility: $input) {
      ecommerceSkuMappingBonusEligibility {
        id
      }
    }
  }
`

export const UPDATE_PLAN_BONUS = gql`
  mutation EcommerceSkuMappingBonusEligibilityUpdateById(
    $input: EcommerceSkuMappingBonusEligibilityUpdateByIdInput!
  ) {
    ecommerceSkuMappingBonusEligibilityUpdateById(ecommerceSkuMappingBonusEligibility: $input) {
      ecommerceSkuMappingBonusEligibility {
        id
      }
    }
  }
`

export const DELETE_PLAN_BONUS = gql`
  mutation EcommerceSkuMappingBonusEligibilityDeleteById(
    $input: EcommerceSkuMappingBonusEligibilityDeleteByIdInput!
  ) {
    ecommerceSkuMappingBonusEligibilityDeleteById(ecommerceSkuMappingBonusEligibility: $input) {
      ecommerceSkuMappingBonusEligibility {
        id
      }
    }
  }
`

export const CREATE_PLAN_GRID = gql`
  mutation CreateBillingPlanGrid($input: CreateBillingPlanGridInput!) {
    createBillingPlanGrid(input: $input) {
      id
    }
  }
`

export const UPDATE_PLAN_GRID = gql`
  mutation UpdateBillingPlanGrid($input: UpdateBillingPlanGridInput!) {
    updateBillingPlanGrid(input: $input) {
      id
    }
  }
`
